import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ab-duration',
  templateUrl: './ab-duration.component.html',
  styleUrls: ['./ab-duration.component.scss']
})
export class AbDurationComponent implements OnInit {

 @Input() element: any;
  constructor() { }

  ngOnInit(): void {
  }

}
